import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';
import { drawPath } from '@/utils/helpers/train-simulation/draw-path';

const pathBlack = new Path2D('M0 0H102V148H0V0Z');
const pathOrange = new Path2D('M76 6H6V112L76 6Z');
const pathOrange2 = new Path2D('M26 142H96V36L26 142Z');
const pathWhite = new Path2D('M96 6H80L6 116V142H22L96 32V6Z');
const pathArrow = new Path2D('M51 178L33 148H69L51 178Z');

export const createSlowSectionAtlas = (isLarge: boolean = false): string => {
  const res = createCanvas(102, 178);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  drawPath(ctx, pathBlack, { fill: '#010100' });
  drawPath(ctx, pathOrange, { fill: isLarge ? '#fe7a00' : '#010100' });
  drawPath(ctx, pathOrange2, { fill: isLarge ? '#fe7a00' : '#010100' });
  drawPath(ctx, pathWhite, { fill: '#ffffff' });

  if (isLarge) {
    drawPath(ctx, pathArrow, { fill: '#191919' });
  }

  return canvas.toDataURL();
};
